import { Shield, AlertTriangle, Zap } from 'lucide-react';

export { formatDate, formatDateShort, DAY_RANGES } from './varianceConfig';

export const reconStates = {
  normal: {
    key: 'normal',
    label: 'Clear',
    icon: Shield,
    bg: 'bg-teal-50',
    text: 'text-teal-700',
    border: 'border-teal-200',
    dot: 'bg-teal-500',
    badgeBg: 'bg-teal-50',
    badgeBorder: 'border-teal-200',
    badgeText: 'text-teal-700',
    rowBg: '',
    accent: 'var(--accent)',
    chartColor: '#45B7AA',
  },
  watch: {
    key: 'watch',
    label: 'Watch',
    icon: AlertTriangle,
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    border: 'border-amber-200',
    dot: 'bg-amber-500',
    badgeBg: 'bg-amber-50',
    badgeBorder: 'border-amber-200',
    badgeText: 'text-amber-700',
    rowBg: 'bg-amber-50/50',
    accent: 'var(--warning)',
    chartColor: '#d97706',
  },
  alert: {
    key: 'alert',
    label: 'Alert',
    icon: Zap,
    bg: 'bg-red-50',
    text: 'text-red-700',
    border: 'border-red-200',
    dot: 'bg-red-500',
    badgeBg: 'bg-red-50',
    badgeBorder: 'border-red-200',
    badgeText: 'text-red-700',
    rowBg: 'bg-red-50/50',
    accent: 'var(--danger)',
    chartColor: '#dc2626',
  },
};

export const getReconState = (unmatchedDispatches, missingThreshold) => {
  if (!unmatchedDispatches || unmatchedDispatches === 0) return reconStates.normal;
  if (unmatchedDispatches < missingThreshold) return reconStates.watch;
  return reconStates.alert;
};

export const formatMatchRate = (rate) => {
  if (rate == null) return '--';
  return `${parseFloat(rate).toFixed(1)}%`;
};

export const formatHours = (hours) => {
  if (hours == null) return '--';
  if (hours < 24) return `${hours}h`;
  const d = Math.floor(hours / 24);
  const h = hours % 24;
  return h > 0 ? `${d}d ${h}h` : `${d}d`;
};

export const formatWeight = (value) => {
  if (value == null) return '--';
  return parseFloat(value).toLocaleString('en', { maximumFractionDigits: 1 }) + 't';
};
